import React, { useState, useEffect, useRef } from "react";
import { ProgressBar, Spinner, Card, Modal, Button, Form, Image, Container, Row, Col, Offcanvas } from 'react-bootstrap';
import { FaMicrophone, FaPaperPlane, FaArrowLeft, FaDollarSign, FaEllipsisH, FaVideo, FaTimes, FaGlasses, FaEye, FaRegEyeSlash, FaRegEye, FaFileDownload } from "react-icons/fa";
import { signInWithGoogle, auth, provider, signInWithPopup, onAuthStateChanged } from "./firebase";
import 'bootstrap/dist/css/bootstrap.min.css';
import emailjs from "emailjs-com";

import { useNavigate, useLocation } from "react-router-dom";
import { runTransaction, deleteField, getFirestore, doc, setDoc, getDoc, collection,query, where, getDocs, addDoc, serverTimestamp, onSnapshot, orderBy, updateDoc, deleteDoc} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import mixpanel from 'mixpanel-browser';


const db = getFirestore();

const ActiveConsultantChat = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const storage = getStorage();
    const messagesEndRef = useRef(null); // Ref for auto-scrolling
    const messageSentRef = useRef(false);
    const consultantJoinMessageSent = useRef(false);
    const [showMoreOptions, setShowMoreOptions] = useState(false);

    const videoInputRef = useRef(null);


    if (sessionStorage.getItem("hasMessageBeenSent") === null) {
      sessionStorage.setItem("hasMessageBeenSent", "false");}

    // let hasMessageBeenSent = sessionStorage.setItem("hasMessageBeenSent", "false");

    // chat timer
    const [seconds, setSeconds] = useState(0);

    // const [user, setUser] = useState(null);
    const userData = location.state?.userData;
    // const [consultant, setConsultant] = useState(null);
    var consultant = location.state?.consultant;
    const [isConsultantActive, setIsConsultantActive] = useState(true);
    
    // console.log('consultant: ', consultant)
    // console.log('userData: ', userData)

    
    const [imageUrl, setImageUrl] = useState(consultant?.photoURL || "/default-avatar.png");

    // activechat
    // const [activeChat, setActiveChat] = useState(null);
    var activeChat = location.state?.activeChat;
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [recording, setRecording] = useState(false);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const [chatInput, setChatInput] = useState("");
    const [userEmail, setUserEmail] = useState("");
    
    // credits
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [credits, setCredits] = useState(null); // Default 0 credits
    const [timeRemaining, setTimeRemaining] = useState(0);
    const [showRechargeModal, setShowRechargeModal] = useState(false);
    const countdownRef = useRef(null);

    // consultation invoice
    const [consultationAmount, setConsultationAmount] = useState('');
    const [showConfirmConsultantInvoiceModal, setShowConfirmConsultantInvoiceModal] = useState(false);

    // list of invoices
    const [consultantInvoices, setConsultantInvoices] = useState([]);
    const [showInvoicesModal, setShowInvoicesModal] = useState(false);


    // sacrifice invoice
    const [sacrificeAmount, setSacrificeAmount] = useState('');
    const [paymentCurrency, setPaymentCurrency] = useState('Naira');
    const [sacrificeDescription, setSacrificeDescription] = useState('');
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    // const [paymentMethod, setPaymentMethod] = useState('stripe');
  
    // end chat
    const [showEndChatModal, setShowEndChatModal] = useState(false);
    const [showChatEndedModal, setShowChatEndedModal] = useState(false);

    {/* End Chat Confirmation Modal */}
    const [isChecked, setIsChecked] = useState(false);

    const [isDivining, setIsDivining] = useState(false);

    const [showCreditFinishedModal, setShowCreditFinishedModal] = useState(false);

      // decrypting
      const [selectedMessage, setSelectedMessage] = useState(null);
      const [decryptedText, setDecryptedText] = useState('');
      const [showDecryptModal, setShowDecryptModal] = useState(false);
      const [passphrase, setPassphrase] = useState('');
      const [globalDecryptionKey, setGlobalDecryptionKey] = useState(null);
      const [decryptedMessages, setDecryptedMessages] = useState({});


      const [audioErrors, setAudioErrors] = useState({});


      // When user clicks "View message" or triggers decryption
        const handleRequestDecrypt = (msg) => {
          if (globalDecryptionKey !== null) {
            // If key exists, decrypt immediately without showing modal
            decryptAllMessages();
                // decryptSingleMessage(msg, globalDecryptionKey);
          } else {
            setShowDecryptModal(true);
          }
        };


     // fill questionaires
      const [formData, setFormData] = useState({
        name: "",
        dob: "",
        motherName: "",
        fatherName: "",
        birthPlace: "",
        origin: "",
        dieties: "",
        rivers: "",
        facePhoto: null,
        rightPalmPhoto: null,
        leftPalmPhoto: null,
      });


// "consultantKey"
  // const consultantPassphrase = passphrase; // Replace with dynamic value if needed
  const fixedSalt = new TextEncoder().encode("fixedSalt");
  const GLOBAL_KEYPHRASE = "globallyPhrased";

  async function getKeyFromPassphrase(passphrase) {
    const encoder = new TextEncoder();
    const salt = encoder.encode("fixedSalt");
    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(passphrase),
      "PBKDF2",
      false,
      ["deriveKey"]
    );
    return crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt,
        iterations: 100000,
        hash: "SHA-256"
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      true,
      ["encrypt", "decrypt"]
    );
  }

  async function decryptText(cipherText, ivArray, key) {
    const binary = Uint8Array.from(atob(cipherText), c => c.charCodeAt(0));
    const iv = new Uint8Array(ivArray);
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      binary
    );
    return new TextDecoder().decode(decrypted);
  }


  async function encryptText(plainText, key) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encoded = new TextEncoder().encode(plainText);
    const cipherBuffer = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      encoded
    );
    return {
      cipherText: btoa(String.fromCharCode(...new Uint8Array(cipherBuffer))),
      iv: Array.from(iv)
    };
  }


  // Auto-scroll to the latest message
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);


useEffect(() => {
  if (!activeChat || !consultant?.id) return;

  const unsubscribe = onSnapshot(
    query(
      collection(db, "chatRooms", activeChat.chatRoomId, "messages"),
      orderBy("createdAt")
    ),
    async (snapshot) => {
      const rawMessages = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        ref: doc.ref
      }));


      // // If we have a global key, decrypt each message's text
      // if (globalDecryptionKey) {
      //   const decryptedMessages = await Promise.all(
      //     rawMessages.map(async (msg) => {
      //       try {
      //         console.log('msg[`encryptedKeyFor${consultant.id}`]: ', msg[`encryptedKeyFor${consultant.id}`])
      //         // console.log('msg.type: ', msg.type)
      //         console.log('msg.text: ', msg.text)

      //         if (msg.type === "text" && msg[`encryptedKeyFor${consultant.id}`]) {
      //           // Step 1: Decrypt message-specific AES key
      //           const decryptedKeyStr = await decryptText(
      //             msg[`encryptedKeyFor${consultant.id}`],
      //             msg[`encryptedKeyFor${consultant.id}Iv`],
      //             globalDecryptionKey
      //           );

      //           const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
      //           const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);

      //           // Step 2: Decrypt the message text
      //           const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
      //            console.log('receiveth')

      //           return { ...msg, decryptedText };
      //         } else {
      //           console.log('doesnt receiveth')
      //           return msg;
      //         }
      //       } catch (err) {
      //         console.error("Decryption error:", err);
      //         return msg;
      //       }
      //     })
      //   );

          // setMessages(rawMessages);
        // setMessages(decryptedMessages);

        // ✅ Update consultant lastSeen
        if (rawMessages.length > 0) {
          const chatRef = doc(db, "chatRooms", activeChat.chatRoomId);
          await updateDoc(chatRef, {
            [`lastSeen.${consultant.id}`]: serverTimestamp()
          });
        }

      // } else {
        // No global key, just display raw messages
        setMessages(rawMessages);
      // }
    }
  );

  return () => unsubscribe();
}, [activeChat, consultant?.id, globalDecryptionKey]);


  useEffect(() => {
    const loadSavedKey = async () => {
      if (!consultant?.id) return;

      const savedBase64 = localStorage.getItem("decryptionKeyFor_" + consultant.id);
      if (savedBase64) {
        try {
          const rawKey = Uint8Array.from(atob(savedBase64), c => c.charCodeAt(0));
          const importedKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
          setGlobalDecryptionKey(importedKey);
        } catch (err) {
          console.error("Failed to import saved key", err);
          localStorage.removeItem("decryptionKeyFor_" + consultant.id); // fallback
        }
      }
    };

    loadSavedKey();
  }, [consultant?.id]);
// na here o!!!
  useEffect(() => {
  if (globalDecryptionKey && messages.length) {
    decryptAllMessages();
  }
}, [messages, globalDecryptionKey]);


// useEffect(() => {
//   if (!consultant?.id) return;
//   const base64Key = localStorage.getItem("decryptionKeyFor_" + consultant.id);
//   if (base64Key) {
//     const rawKey = Uint8Array.from(atob(base64Key), c => c.charCodeAt(0));
//     crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]).then(key => {
//       setGlobalDecryptionKey(key);
//       decryptAllMessages(key);
//     });
//   }
// }, [consultant?.id]);





    // Listen for "ended" Status
    useEffect(() => {
      if (activeChat && activeChat.chatRoomId) {
        const chatRequestRef = doc(db, "chatRooms", activeChat.chatRoomId);
        // console.log('user sending ending req')
        const unsubscribe = onSnapshot(chatRequestRef, (docSnapshot) => {
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            // console.log('chat status1: ', data.status)

            if (data.status === "ended") {
              // console.log('chat status2: ', data.status)
              // Show a modal to inform the consultant that the user ended the chat
              setShowChatEndedModal(true);
              // precaution:its causing errors when you end session from consultant and 
              // then request again so:
              setShowEndChatModal(false)
            }
          }
        });
    
        return () => unsubscribe();
      }
    }, [activeChat]);

     useEffect(() => {
          if (consultant?.id) {
              const userRef = doc(db, "priest_users", consultant.id);
              const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
                  if (docSnapshot.exists()) {
                      setCredits(docSnapshot.data().credits || 0);
                  }
              });
              return () => unsubscribe();
          }
      }, [consultant]);

      // Pay consultant every 1 minute
      useEffect(() => {
        // console.log('userData: ', userData)
        // console.log('consultant: ', consultant)
        const priestsPayUserRef = doc(db, "priestsPay", consultant.id, "users", userData.id);


        if (consultant?.id && activeChat?.chatRoomId && userData?.id) {
          const consultantRef = doc(db, "priest_users", consultant.id);
          const userRef = doc(db, "priest_users", userData.id);
          const chatRef = doc(db, "chatRequests", activeChat.chatRoomId);
      
          const interval = setInterval(async () => {
            try {
              // Check if the chat is active and the consultant is on screen
              if (!isConsultantActive) return;
      
              // Fetch the latest chat status
              const chatSnapshot = await getDoc(chatRef);
              if (chatSnapshot.exists() && chatSnapshot.data().status === "ended") {
                clearInterval(interval);
                return;
              }
      
              // Use Firestore transaction to ensure atomic updates
              await runTransaction(db, async (transaction) => {
                const userSnap = await transaction.get(userRef);
                const consultantSnap = await transaction.get(consultantRef);
                const paySnap = await transaction.get(priestsPayUserRef);

                if (!userSnap.exists() || !consultantSnap.exists()) {
                  throw new Error("User or Consultant does not exist");
                }

                // Get the latest user and consultant credits
                const userCredits = Number(userSnap.data()?.credits) || 0;
                const consultantCredits = Number(consultantSnap.data()?.credits) || 0;
                const rate = Number(consultant.ratePerMinute);
      
                if (userCredits < rate) {
                  console.log('userCredits: ', userCredits)
                  console.log('rate: ', rate)
                  setShowCreditFinishedModal(true);
                  throw new Error("Insufficient credits");
                }
      
                // Deduct from the user
                transaction.update(userRef, { credits: userCredits - rate });

                // console.log("consultantRef: ", consultantRef)
                // console.log("consultantCredits: ", consultantCredits)
                // console.log("rate: ", rate)
                // console.log("rate: ", userCredits)


                // Credit the consultant
                transaction.update(consultantRef, { credits: consultantCredits + rate });

                // Update or initialize payment history
                const currentPayData = paySnap.exists() ? paySnap.data() : { totalAmountPaid: 0 };
                const newTotalPaid = currentPayData.totalAmountPaid + rate;

                transaction.set(priestsPayUserRef, {
                  totalAmountPaid: newTotalPaid,
                  lastPaidAt: new Date()
                });
              });
      
              // Update local state
              setCredits((prev) => prev + Number(consultant.ratePerMinute));
            } catch (error) {
              console.error("Transaction failed:", error);
            }
          }, 60000);
      
          return () => clearInterval(interval);
        }
      }, [consultant, activeChat, isConsultantActive, userData]);
  

  

  
    // Listen for authentication state changes
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
       
      });
  
      return () => unsubscribe(); // Cleanup listener on unmount
    }, []);


    useEffect(() => {
      fetchProfilePhoto();
    }, []);


    useEffect(() => {
      const handleVisibilityChange = () => {
        setIsConsultantActive(!document.hidden);
      };
    
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);


//  send first message
  useEffect(() => {
      if (!activeChat?.chatRoomId) return;
        // console.log('consultantJoinMessageSent: ', consultantJoinMessageSent)
        // console.log('hasMessageBeenSent: ', sessionStorage.getItem("hasMessageBeenSent"))
        if (consultantJoinMessageSent.current === false && sessionStorage.getItem("hasMessageBeenSent") === "false") {
          sendConsultantJoinMessage();
          sessionStorage.setItem("hasMessageBeenSent", "true")
          // console.log('hasMessageBeenSent: ', sessionStorage.getItem("hasMessageBeenSent"))
        }
  }, [activeChat]);



  //Get email of user
  useEffect(() => {
    if (!activeChat?.chatRoomId || !userData?.id) return;

    const fetchUserEmail = async () => {
      try {
        const userRef = doc(db, "priest_users", userData.id);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const data = userSnap.data();
          setUserEmail(data.email);
          // console.log("userEmail: ", data.email);
        } else {
          console.log("No such user document!");
        }
      } catch (error) {
        console.error("Error fetching user email:", error);
      }
    };

    fetchUserEmail();
  }, [userData]);



  const sendConsultantJoinMessage = async () =>{

    if (consultant?.id && activeChat?.chatRoomId && !messageSentRef.current) {
        // const timestamp = new Date().toLocaleTimeString(); // Get current time when consultant enters
        const message = `Consultant joined the chat. `; // Message content

        try {
          await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
            text: message,
            sender: consultant.name || "Consultant",
            type: "text",
            createdAt: serverTimestamp(),
            photoURL: consultant.photoURL || "/default-avatar.png"
          });

        } catch (error) {
          console.error("Error sending message:", error);
        }

    }

  }
    


  const sendMessage = async () => {
        // console.log('userData: ', userData)
        // console.log('activeChat: ', activeChat)
        // console.log('consultant: ', consultant)

        if (!chatInput.trim() || !activeChat?.chatRoomId) return;

        if (!passphrase || passphrase.trim() === '') {
          // alert("Please set a secret key before sending messages.");
          setShowDecryptModal(true)
          return;
        }

        try {

          // Step 1: Generate a random AES key for this message
          const aesKey = await crypto.subtle.generateKey(
            { name: "AES-GCM", length: 256 },
            true,
            ["encrypt", "decrypt"]
          );

          // Step 2: Encrypt the message with the AES key
          // const { cipherText, iv } = await encryptText(chatInput, aesKey);
          const { cipherText: encryptedMessage, iv: messageIv } = await encryptText(chatInput, aesKey);

          // Step 3: Encrypt the AES key with the consultant’s passphrase
          const globalKey = await getKeyFromPassphrase(GLOBAL_KEYPHRASE);
          // const consultantKey = await getKeyFromPassphrase(consultantPassphrase);
          const exportedKey = await crypto.subtle.exportKey("raw", aesKey);
          const base64Key = btoa(String.fromCharCode(...new Uint8Array(exportedKey)));

          // 4. Encrypt key with sender's passphrase
          const senderKey = await getKeyFromPassphrase(passphrase);
          const { cipherText: encryptedKeyForSender, iv: encryptedKeyForSenderIv } = await encryptText(base64Key, senderKey);

          // 5. Encrypt key with global key
          const { cipherText: encryptedKeyForGlobal, iv: encryptedKeyForGlobalIv } = await encryptText(base64Key, globalKey);

          // 6. Save the message with encrypted key for sender and global
          await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
            // string:chatInput,
            text: encryptedMessage,
            iv: messageIv,
            [`encryptedKeyFor${consultant.id}`]: encryptedKeyForSender,
            [`encryptedKeyFor${consultant.id}Iv`]: encryptedKeyForSenderIv,
            encryptedKeyForGlobal,
            encryptedKeyForGlobalIv,
            encryptedKeyForReceiver: null,
            encryptedKeyForReceiverIv: null,
            [`needsReceiverKeyEncryption${consultant.id}`]: false,
            [`needsReceiverKeyEncryption${userData.id}`]:true,
            sender: consultant?.username?.trim() ? consultant.username : auth.currentUser.displayName,                
            type: "text", // Add this line so the UI knows it's a text message
            photoURL: auth.currentUser.photoURL,
            createdAt: serverTimestamp()
          });


          try {
                // Send alert using EmailJS
              await emailjs.send(
                'service_kxsob6t', 
                'template_h5s0rbm', 
                {
                // userId: user?.uid,
                userName: userData?.name,
                priestName:consultant?.username?.trim() ? consultant.username : auth.currentUser.displayName,
                userEmail:userEmail,
                // to_email: 'info@priests.africa',
                // message: fullReport,
              }, 'iTUAGGcFXyrJu_f0s');

              } catch (error) {
                  console.error("Error uploading audio:", error);
              }

          setChatInput("");
        } catch (error) {
          console.error("Error sending message:", error);
        }
  };

     
    
  async function decryptAllMessages() {
    try {

        let key = globalDecryptionKey;

          if (!key){

              if (!passphrase || passphrase.trim() === '') {
              // alert("Please set a secret key before sending messages.");
              setShowDecryptModal(true)
              return;
            }

            key = await getKeyFromPassphrase(passphrase)
            setGlobalDecryptionKey(key)
          }

          const updatedDecryptedMessages = {};

        for (const msg of messages) {
          let decryptedKeyStr = null;
          let aesKey = null;
          // console.log('e enter 1')
          if (msg[`needsReceiverKeyEncryption${consultant.id}`] && msg.encryptedKeyForGlobal && msg.encryptedKeyForGlobalIv) {
            // console.log('e enter 2')
            // Re-encrypt logic
            try {
              const globalKey = await getKeyFromPassphrase(GLOBAL_KEYPHRASE);

              decryptedKeyStr = await decryptText(
                msg.encryptedKeyForGlobal,
                msg.encryptedKeyForGlobalIv,
                globalKey
              );

              const { cipherText, iv } = await encryptText(decryptedKeyStr, key);
              const needsReEncryption = msg[`needsReceiverKeyEncryption${consultant.id}`];
              console.log("needsReEncryption: ", needsReEncryption)
                
                // if (needsReEncryption) {
                  await updateDoc(msg.ref, {
                    [`encryptedKeyFor${consultant.id}`]: cipherText,
                    [`encryptedKeyFor${consultant.id}Iv`]: iv,
                    [`needsReceiverKeyEncryption${consultant.id}`]: false,
                    encryptedKeyForGlobal: deleteField(),
                    encryptedKeyForGlobalIv: deleteField(),
                  });
                // }

              const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
              aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["encrypt", "decrypt"]);

              const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
              updatedDecryptedMessages[msg.id] = decryptedText;
              continue;
            } catch (err) {
              console.warn(`Skipping message ${msg.id}: failed to re-encrypt key.`, err);
              continue;
            }
          }

          // Decrypt normally if key available
          const encryptedKey = msg[`encryptedKeyFor${consultant.id}`];
          const encryptedKeyIv = msg[`encryptedKeyFor${consultant.id}Iv`];

          if (encryptedKey && encryptedKeyIv) {
            try {
              if (!decryptedKeyStr) {
                decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
              }
              const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
              const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
              const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
              updatedDecryptedMessages[msg.id] = decryptedText;
            } catch (err) {
              console.warn(`Skipping decryption for message ${msg.id}`, err);
            }
          }
        }

        setDecryptedMessages(updatedDecryptedMessages);
      } catch (err) {
        console.error("Error during decryption:", err);
      }
    }


    async function decryptSingleMessage(msg, key) {
      try {
        let decryptedKeyStr = null;
        let aesKey = null;
        const key = await getKeyFromPassphrase(passphrase)

        const encryptedKey = msg[`encryptedKeyFor${consultant.id}`];
        const encryptedKeyIv = msg[`encryptedKeyFor${consultant.id}Iv`];

        if (encryptedKey && encryptedKeyIv) {
          decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
          const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
          aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
          const decryptedText = await decryptText(msg.text, msg.iv, aesKey);

          setDecryptedMessages(prev => ({
            ...prev,
            [msg.id]: decryptedText,
          }));
        }
      } catch (err) {
        console.warn(`Failed to decrypt message ${msg.id}`, err);
      }
}

// ****userData or consultant?????????????????????????
      
       const startRecording = async () => {

        mixpanel.track('recording...', {
            consultant: consultant.name || consultant.username,
            user: userData.id || 'no userid',
          });

          try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            mediaRecorderRef.current = new MediaRecorder(stream);
            audioChunksRef.current = [];
        
            mediaRecorderRef.current.ondataavailable = (event) => {
              if (event.data.size > 0) {
                audioChunksRef.current.push(event.data);
              }
            };
        
            mediaRecorderRef.current.onstop = async () => {
              const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
               // ✅ Fix: Use backticks to form template string
              const filename = `audioMessages/${Date.now()}.wav`;
              const storageRef = ref(storage, filename);

              try {
                // Upload the blob to Firebase Storage
                await uploadBytes(storageRef, audioBlob);
                // Get the download URL for the uploaded file
                const downloadURL = await getDownloadURL(storageRef);
                // Now add the message to Firestore using the permanent download URL
                await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
                  audio: downloadURL,
                  sender: consultant?.username?.trim() ? consultant.username : auth.currentUser.displayName,
                  type: "audio",
                  photoURL: auth.currentUser.photoURL || consultant.photoURL,
                  createdAt: serverTimestamp()
                });

                 try {
                      // Send alert using EmailJS
                    await emailjs.send(
                      'service_kxsob6t', 
                      'template_h5s0rbm', 
                      {
                      // userId: user?.uid,
                      userName: userData?.name,
                      priestName:consultant?.username?.trim() ? consultant.username : auth.currentUser.displayName,
                      userEmail:userEmail,
                      // to_email: 'info@priests.africa',
                      // message: fullReport,
                    }, 'iTUAGGcFXyrJu_f0s');

                    } catch (error) {
                        console.error("Error uploading audio:", error);
                        mixpanel.track('startRecordingError1', {
                        error: error,
                        consultant: consultant.id
                })
                    }
              } catch (error) {
                console.error("Error uploading audio:", error);
                 mixpanel.track('startRecordingError1', {
                  error: error,
                  consultant: consultant.id
                })
              }
              setRecording(false);
               
            };
        
            mediaRecorderRef.current.start();
            setRecording(true);
          } catch (error) {
            console.error("Error starting recording:", error);
          }
        };
      
         const stopRecording = () => {
          try {
            if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);
          }
          } catch (error) {
              console.error("Error stopping recording:", error);
              mixpanel.track('stopRecording', {
                error: error,
                consultant: consultant.id || 'unknown consultant.id'
              })
          }
        };


        const handleDeleteChat = async () => {
            
        
          if (!activeChat?.chatRoomId) return;
      
        try {
          await updateDoc(doc(db, "chatRequests", activeChat.chatRoomId), {
            status: "ended"
          });
      
          setShowEndChatModal(false);
          setShowChatEndedModal(false)
          consultant=null;
          activeChat=null;
          navigate("/dashboard");
        } catch (error) {
          console.error("Error ending chat:", error);
        }
        };


        const handleEndChat = async () => {

          if (!activeChat?.chatRoomId) return;


          // const timestamp = new Date().toLocaleTimeString(); // Get current time when consultant enters
          const message = `Consultant left the chat. `; // Message content

          try {
            await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
              text: message,
              sender: consultant.name || "Consultant",
              type: "text",
              createdAt: serverTimestamp(),
              photoURL: consultant.photoURL || "/default-avatar.png"
            });
            messageSentRef.current = true;  // Mark the message as sent
          } catch (error) {
            console.error("Error sending message:", error);
          }
        
            setShowEndChatModal(false);
            setShowChatEndedModal(false)
            consultant=null;
            activeChat=null;
            sessionStorage.removeItem("hasMessageBeenSent")
            navigate("/dashboard");
        
          };
        
          const handleChatEndedModal = () => {
            setShowChatEndedModal(false)
            consultant=null;
            activeChat=null;
            navigate("/dashboard");

          }

           // Fetch user profile photo from Firestore
            const fetchProfilePhoto = async () => {
              try {
                if (!consultant?.id) return; // Early exit if consultant doesn't have an id
          
                const userDocRef = doc(db, "priest_users", consultant.id);
                const docSnap = await getDoc(userDocRef);
          
                if (docSnap.exists()) {
                  const data = docSnap.data();
                  if (data.photoURL) {
                    setImageUrl(data.photoURL);
                  }
                }
              } catch (error) {
                console.error("Error fetching profile photo:", error);
              }
            };




  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };


  const handleContinueSession = async () => {
    // const timestamp = new Date().toLocaleTimeString(); // Get current time when consultant enters
    const message = `Sorry, you've got insufficient credit to continue this session but I'll give you 1 minute for free. `; // Message content

    try {
      await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
        text: message,
        sender: consultant.name || "Consultant",
        type: "text",
        createdAt: serverTimestamp(),
        photoURL: consultant.photoURL || "/default-avatar.png"
      });
      messageSentRef.current = true;  // Mark the message as sent
    } catch (error) {
      console.error("Error sending message:", error);
    }
    setShowCreditFinishedModal(false);
    // Logic to continue session even with insufficient credits
  };
  
  const handleEndSession = async () => {

        // Logic to end session
    if (!activeChat?.chatRoomId) return;


          // const timestamp = new Date().toLocaleTimeString(); // Get current time when consultant enters
          const message = `Sorry, you've got insufficient credit to continue the session. `; // Message content

          try {
            await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
              text: message,
              sender: consultant.name || "Consultant",
              type: "text",
              createdAt: serverTimestamp(),
              photoURL: consultant.photoURL || "/default-avatar.png"
            });
            messageSentRef.current = true;  // Mark the message as sent
          } catch (error) {
            console.error("Error sending message:", error);
          }
        
            setShowEndChatModal(false);
            setShowChatEndedModal(false)
            consultant=null;
            activeChat=null;
            sessionStorage.removeItem("hasMessageBeenSent")
            navigate("/dashboard");

          setShowCreditFinishedModal(false);

  };

    const handleVideoUpload = async (event) => {
      const file = event.target.files[0];
      if (!file) return;
    
      const maxSizeMB = 30;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;
      let finalFile = file;
    
      if (file.size > maxSizeBytes) {
        alert("video is larger than 30mb...try sending smaller sized video");
          // try {
          //   finalFile = await compressAndUploadVideo(file);
          //   if (finalFile.size > maxSizeBytes) {
          //     alert("Compressed video still too large. Try recording a shorter video.");
          //     return;
          //   }
          // } catch (err) {
          //   console.error("Compression failed", err);
          //   alert("Compression failed. Try again or record a smaller video.");
          //   return;
          // }
          mixpanel.track('videoSizeError', {
            error: "video is larger than 30mb...try sending smaller sized video",
            consultant: consultant.id || consultant.uid
          })
      }
    
      const filename = `videoMessages/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, filename);
    
      try {
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
    
        await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
          video: downloadURL,
          sender: consultant?.username?.trim() ? consultant.username : auth.currentUser.displayName,
          type: "video",
          createdAt: serverTimestamp(),
          photoURL: auth.currentUser.photoURL
        });
    
        alert("Video sent!");
      } catch (error) {
        console.error("Error uploading video:", error);
        alert("Error uploading video");
      }
    };


    const compressAndUploadVideo = async (file) => {
      return new Promise((resolve, reject) => {
        const video = document.getElementById('videoPreview');
        const url = URL.createObjectURL(file);

        video.src = url;
        video.load();

        video.onloadedmetadata = () => {
          // Set playback size to smaller resolution
          video.width = 320;
          video.height = 240;

          const stream = video.captureStream(); // record what’s being played
          const options = { mimeType: 'video/webm; codecs=vp9' };
          const mediaRecorder = new MediaRecorder(stream, options);

          let chunks = [];

          mediaRecorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
              chunks.push(e.data);
            }
          };

          mediaRecorder.onstop = async () => {
            const compressedBlob = new Blob(chunks, { type: 'video/webm' });
            const compressedFile = new File([compressedBlob], 'compressed.webm', { type: 'video/webm' });

            resolve(compressedFile);
          };

          mediaRecorder.onerror = (e) => reject(e.error || e);

          video.play();
          mediaRecorder.start();

          // Stop recording when the video ends
          video.onended = () => {
            mediaRecorder.stop();
            URL.revokeObjectURL(url);
          };
        };
      });
    };



    // Handle sending the sacrifice invoice
    const handleSendInvoice = async () => {
      // Send the invoice to the recipient with the sacrifice amount and description
      try {
        console.log('currency: ', paymentCurrency)
        await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
          text: `Sacrifice Invoice: ${sacrificeDescription}`,
          sender: consultant?.username || auth.currentUser.displayName,
          type: "invoice",
          status: "unpaid",
          amount: sacrificeAmount,
          description: sacrificeDescription,
          currency: paymentCurrency,
          createdAt: serverTimestamp(),
        });

           // Close the canvas after sending the message
           if (showMoreOptions) {
            setShowMoreOptions(false); // Only close when result is ready
          }

        // Optionally, notify the recipient in a different way
        // alert("Sacrifice Invoice sent successfully!");
        setShowInvoiceModal(false)
      

      } catch (error) {
        console.error("Error sending invoice:", error);
      }
    };


    // Handle sending the sacrifice invoice
    const sendConsultationInvoice = async () => {
      // Send the invoice to the recipient with the sacrifice amount and description
      try {
        await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
          text: `Consultation Invoice`,
          sender: consultant?.username || auth.currentUser.displayName,
          type: "invoice",
          status: "unpaid",
          amount: consultant.consultationCharge,
          currency: "USD",
          // paymentMethod: paymentMethod,
          createdAt: serverTimestamp(),
        });

         // Close the canvas after sending the message
        //  if (showMoreOptions) {
        // console.log(showConfirmConsultantInvoiceModal)
        // console.log(showConfirmConsultantInvoiceModal)
          setShowConfirmConsultantInvoiceModal(false)
          setShowMoreOptions(false); // Only close when result is ready
        // }
    
        // Optionally, notify the recipient in a different way
        // alert("Consultation Invoice sent successfully!");
    
      } catch (error) {
        console.error("Error sending invoice:", error);
      }
    };


    const viewInvoices = async () => {
      if (!activeChat?.chatRoomId || !consultant?.id) return;
    
      try {
        const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
        const q = query(messagesRef, where("type", "==", "invoice")); // assuming consultant.username is used when sending
    
        const snapshot = await getDocs(q);
        const invoices = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        console.log("invoices: ", invoices)
        setConsultantInvoices(invoices);
        setShowInvoicesModal(true);
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };


    const handleDeleteInvoice = async (invoiceId) => {
      if (!activeChat?.chatRoomId || !invoiceId) return;
    
      try {
        const invoiceRef = doc(db, "chatRooms", activeChat.chatRoomId, "messages", invoiceId);
        await deleteDoc(invoiceRef);
        setConsultantInvoices(prev => prev.filter(inv => inv.id !== invoiceId));
      } catch (error) {
        console.error("Failed to delete invoice:", error);
      }
    };
    
    
  

    //   if (activeChat) {
  return (
    <div className="chat-container">
       <div className="chat-header">
        <Container fluid className="d-flex flex-column vh-100">
              {/* Header */}
              <Row className="p-2 bg-white shadow-sm align-items-center">
               {/* <Col xs="auto"> */}
                  <Button variant="link" className="text-dark" onClick={() => setShowEndChatModal(true)}>
                    <FaTimes size={20} />
                  </Button>
                {/* </Col> */}
                <Col className="d-flex align-items-center">
                    <Image
                        src={activeChat.user.photoURL || "https://via.placeholder.com/40"}
                        roundedCircle
                        width={30}
                        height={30}
                        className="me-2"
                        />
                       <h5 className="mb-0" > {activeChat.user.name}</h5>
                </Col>

    
                <Col xs="auto">
                  <Button variant="light" onClick={'openRechargeModal'}>
                    {/* Time Elapsed: {formatTime(seconds)}  */}
                    {credits === null ? "Loading..." : credits.toFixed(2)}
                    <img 
                      src="/cowrieblack.png" // Update with the correct path
                      alt="Feather Icon" 
                      style={{ width: '20px', height: '20px'}} 
                    />
                  </Button>

                  {/* More Button */}
                  <Button className="me-0"
                    variant="success"
                    onClick={() => setShowMoreOptions(true)}
                  >
                    <FaEllipsisH />
                  </Button>
                </Col>
              </Row>

             
               {/* Hidden video element used for video compression */}
                <video
                  id="videoPreview"
                  style={{ display: "none" }}
                  muted
                  playsInline
                />


              {/* Chat Messages */}
              <Row className="flex-grow-1 overflow-auto p-3" style={{ paddingBottom: "80px" }}>
                <Col>
                  {messages.map((msg) => (
                    <div key={msg.id} className={`d-flex ${msg.sender === activeChat.user.name ? "justify-content-start" : "justify-content-end"} align-items-center mb-3`}>
                      {/* Sender Profile Picture */}
                      {msg.sender === activeChat.user.name && (
                        <Image
                          src={activeChat.user.photoURL || "https://via.placeholder.com/40"}
                          roundedCircle
                          width={40}
                          height={40}
                          className="me-2"
                        />
                      )}

                      
        
                      {/* Message Bubble */}
                      <div className={`p-3 rounded shadow ${msg.sender === activeChat.user.name ? "bg-light text-dark" : "bg-success text-white"}`} style={{ maxWidth: "80%", marginBottom:30}}>
                          <strong className="d-block small">{msg.sender === activeChat.user.name ? msg.sender : consultant?.username?.trim() ? consultant.username : consultant.name}</strong>
                          {/* {msg.type === "text" ? (
                            <span>{msg.text}</span>
                            
                          ) : (
                            <audio controls src={msg.audio} className="mt-1" />
                          )} */}
                           {/* Check the message type and display accordingly */}
                            {msg.type === "text" ? (
                              <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setSelectedMessage(msg);
                                  setDecryptedText('');
                                  // setPassphrase('');
                                  // setShowDecryptModal(true);
                                  handleRequestDecrypt(msg)
                                }}
                              >
                                {/* {decryptedMessages[msg.id] || msg.text} */}
                                  {decryptedMessages[msg.id] ? (
                                    <span>{decryptedMessages[msg.id]}</span>
                                  ) : (
                                    <div>
                                      <div>{msg.text}</div>
                                    </div>

                                  )}
                              </span>
                            ) : msg.type === "audio" ? (
                                  <div className="d-flex align-items-center gap-2 mt-2">
                                  {audioErrors[msg.id] ? (
                                    <div className="text-danger small">
                                      Cannot play voice note.
                                    </div>
                                  ) : (
                                    <audio
                                      controls
                                      src={msg.audio}
                                      onError={(e) => {
                                        console.error("Audio error for msg: ", msg, e);
                                        mixpanel.track('audioError', {
                                          error: msg,
                                          consultant: consultant.id
                                        });
                                        setAudioErrors(prev => ({ ...prev, [msg.id]: true }));
                                      }}
                                      className="flex-grow-1"
                                      style={{ minWidth: "150px" }}
                                    />
                                  )}

                                  <a
                                    href={msg.audio}
                                    download
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center shadow"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      flexShrink: 0,
                                      flexGrow: 0,
                                      padding: 0,
                                      border: "1px solid rgba(255,255,255,0.5)",
                                    }}
                                    title="Download audio"
                                  >
                                    <i className="bi bi-download" style={{ fontSize: "18px", color: "#000", filter: "none" }} />
                                    {/* <FaFileDownload size={18} /> */}
                                  </a>
                                  </div>
                            )
                            : msg.type === "video" ? (
                              <video controls width="100%" style={{ maxHeight: 200 }}>
                                <source src={msg.video} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            ) : msg.type === "invoice" ? (
                                <div className="mt-2">
                                  <p className="mb-2"><strong>Invoice</strong> from <em>{consultant?.username?.trim() ? consultant.username : consultant.name}</em>:</p>
                                  <p className="mb-1">{msg.description}</p>
                                  <p className="mb-2 fw-semibold">Amount: {msg.amount} {msg.currency}</p>
                                  <p className="mb-2 fw-semibold">Status: {msg.status}</p>
                                  <Button
                                    // onClick={() => {
                                    //   setSacrificeAmount(msg.amount/2000); // set amount in payment modal: converting from Naira to dollar
                                    //   // setSacrificePaymentMethod(msg.paymentMethod || 'stripe'); // optionally set method
                                    //   setShowSacrificeModal(true); // show modal
                                    // }}
                                    variant="outline-light"
                                    style={{ padding: '6px 20px', fontSize: '14px' }}
                                  >
                                    Pay Now
                                  </Button>
                                </div>
                              ): null}

                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <p style={{ marginTop: '5px', marginBottom: 0, marginLeft: 'auto', fontSize:'12px', }}>
                              {(!decryptedMessages[msg.id] && (
                                    msg[`encryptedKeyFor${consultant.id}`] || msg.encryptedKeyForGlobal
                                  )) && (
                                    <FaRegEyeSlash 
                                    style={{ fontSize: 18, marginRight: '5px', verticalAlign: 'middle' }} 
                                     onClick={() => {
                                      setSelectedMessage(msg);
                                      setDecryptedText('');
                                      // setPassphrase('');
                                      // setShowDecryptModal(true);
                                      handleRequestDecrypt(msg)
                                }}
                                    />
                                )}
                        
                              {msg.createdAt &&
                                '@'+ new Date(msg.createdAt.seconds * 1000).toLocaleTimeString(undefined, {
                                  weekday: 'short',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })}                            
                            </p>
                          </div>                      
                        </div>
        
                      {/* Consultant Profile Picture */}
                      {msg.sender !== activeChat.user.name && (
                        <Image
                          src={consultant.photoURL}
                          roundedCircle
                          width={40}
                          height={40}
                          className="ms-2"
                        />
                      )}
                    </div>
                  ))}
                  
                {/* Auto-scroll to latest message */}
                   <div ref={messagesEndRef} />
                </Col>
              </Row>

              
        
              {/* Fixed Input Box at Bottom */}
              <Row className="p-2 bg-white shadow-sm fixed-bottom">
               
                <Col>
                  <Form className="d-flex align-items-center">
                    <Form.Control
                      type="text"
                      placeholder="Type a message..."
                      value={chatInput}
                      onChange={(e) => setChatInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevents line break in input
                          sendMessage(); // Call your message sending function
                        }
                      }}
                      className="me-1"
                    />
                    <Button variant="success" onClick={sendMessage} className="me-1">
                      <FaPaperPlane />
                    </Button>
                    {recording ? (
                      <Button className="me-1" variant="danger" onClick={stopRecording}>
                        Stop
                      </Button>
                    ) : (
                      <Button className="me-1" variant="primary" onClick={startRecording}>
                        <FaMicrophone />
                      </Button>
                    )}
                    <Button className="me-0"
                    variant="primary"
                    onClick={() => videoInputRef.current.click()}
                  >
                    <FaVideo />

                  </Button>

                  <input
                    type="file"
                    accept="video/*"
                    style={{ display: "none" }}
                    ref={videoInputRef}
                    onChange={handleVideoUpload}
                  />

                     
                  </Form>
                </Col>
              </Row>


              {/* show decrypting modal */}
              <Modal show={showDecryptModal} onHide={() => setShowDecryptModal(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title className="fw-bold text-success">Set Key ?</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4 pb-4">
                     <p className="text-muted small mb-2">
                      🔒 This protects your private conversations from hacking.
                    </p>
                    <p className="text-muted small mb-2">
                      🔑 <b>DO NOT</b> enter a key unless you're <b>100% sure you'll always remember it </b> as keys are not stored by Priests.Africa.
                    </p>
                    <p className="text-muted small mb-4">
                    ⚠️ Entering New keys will result in loss of access to old messages.
                    </p>
                  <Form.Group>
                    {/* <Form.Label className="fw-semibold text-secondary small">Use either your easiest password or most favorite name?</Form.Label> */}
                    <Form.Control
                      placeholder="Enter key?"
                      // type="text"
                      // type="password"
                      value={passphrase}
                      onChange={(e) => setPassphrase(e.target.value)}
                    />
                  </Form.Group>
                  <div className="d-flex justify-content-center mt-4">
                  <Button
                    className="px-4 py-2 rounded-pill shadow-sm"
                    style={{ fontWeight: 500, fontSize: '1rem' }}
                    variant="success"
                    onClick={async () => {
                      try {
                        const key = await getKeyFromPassphrase(passphrase.toLowerCase());
                        const globalKey = await getKeyFromPassphrase(GLOBAL_KEYPHRASE);
        
                        const updatedDecryptedMessages = {};
        
                        for (const msg of messages) {
                          let decryptedKeyStr = null;
                          let aesKey = null;
        
                          if (msg[`needsReceiverKeyEncryption${consultant.id}`] && msg.encryptedKeyForGlobal && msg.encryptedKeyForGlobalIv) {
                            try {
                              // Step 1: Decrypt AES key with global key
                              decryptedKeyStr = await decryptText(
                                msg.encryptedKeyForGlobal,
                                msg.encryptedKeyForGlobalIv,
                                globalKey
                              );
        
                              // Step 2: Re-encrypt AES key with user's passphrase-derived key
                              const { cipherText, iv } = await encryptText(decryptedKeyStr, key);
        
                              // Step 3: Save to Firestore
                              await updateDoc(msg.ref, {
                                [`encryptedKeyFor${consultant.id}`]: cipherText,
                                [`encryptedKeyFor${consultant.id}Iv`]: iv,
                                [`needsReceiverKeyEncryption${consultant.id}`]: false,
                                encryptedKeyForGlobal: deleteField(),
                                encryptedKeyForGlobalIv: deleteField(),
                              });
        
                              const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                              aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
        
                              const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                              updatedDecryptedMessages[msg.id] = decryptedText;
                              continue;
                              
                            } catch (err) {
                              console.warn(`Skipping message ${msg.id}: failed to re-encrypt key.`, err);
                              continue; // Skip failed ones
                            }
                          }
        
                          // Try decrypting if AES key encrypted with consultant passphrase exists
                          const encryptedKey = msg[`encryptedKeyFor${consultant.id}`];
                          const encryptedKeyIv = msg[`encryptedKeyFor${consultant.id}Iv`];
        
                          if (encryptedKey && encryptedKeyIv) {
                            try {
                              if (!decryptedKeyStr) {
                                decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
                              }
        
                              const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                              const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
        
                              const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                              updatedDecryptedMessages[msg.id] = decryptedText;
                            } catch (err) {
                              // Don't set error message — just skip silently
                              console.warn(`Skipping decryption for message ${msg.id}`, err);
                            }
                          }
                        }
        
                        // ✅ Update decrypted messages state (or however you're storing it)
                        setDecryptedMessages(updatedDecryptedMessages);
                        setGlobalDecryptionKey(key);
                        // Save base64 version to localStorage for reuse
                        const exported = await crypto.subtle.exportKey("raw", key);
                        const base64Key = btoa(String.fromCharCode(...new Uint8Array(exported)));
                        localStorage.setItem("decryptionKeyFor_" + consultant.id, base64Key);
                        // ✅ Refresh the page to re-render with decrypted messages
                        // window.location.reload();
                        setShowDecryptModal(false); // Close modal
                      } catch (err) {
                        console.error("Error during decryption:", err);
                        // Optionally: setDecryptedText("Decryption failed."); but no need in this UX
                      }
                    }}
                  >
                    <FaRegEye/> Decrypt
                  </Button>
                  </div>
        
        
        
        
        
                  {decryptedText && (
                    <div className="mt-3">
                      <strong>Decrypted Message:</strong>
                      <div className="border p-2 mt-2">{decryptedText}</div>
                    </div>
                  )}
                </Modal.Body>
              </Modal>


    
    
             {/* End Chat Confirmation Modal */}
          <Modal show={showEndChatModal} onHide={() => setShowEndChatModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>leave chat?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to leave this chat?

              <Form margin>
              <div className="mt-3">
                <Form.Check
                  type="checkbox"
                  id="end-chat-checkbox"
                  label="Activate 'END Charges' button?"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
              </div>
            </Form>
            </Modal.Body>

            
            <Modal.Footer>
            <Button variant="danger" onClick={handleDeleteChat} disabled={!isChecked}>
              END Charges
            </Button>
            <Button variant="success" onClick={handleEndChat}>
                Leave Chat
              </Button>
              <Button variant="secondary" onClick={() => setShowEndChatModal(false)}>
                Stay
              </Button>
              
            </Modal.Footer>
          </Modal>
    
          <Modal show={showChatEndedModal} onHide={handleChatEndedModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Chat Ended</Modal.Title>
          </Modal.Header>
          <Modal.Body>The user has ended the chat.</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleChatEndedModal}>
              Close Chat
            </Button>
          </Modal.Footer>
        </Modal>
            </Container>
    </div>

    <>
      {/* Modal for insufficient credits */}
      <Modal show={showCreditFinishedModal} onHide={() => setShowCreditFinishedModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Insufficient Credits</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This user has exhausted their credits. Do you want to <span className="fw-bold text-dark"> continue the session or end it? </span> We will remind you every 1 minute if you decide to continue.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleEndSession}>
            End Session
          </Button>
          <Button variant="success" onClick={handleContinueSession}>
            Continue Session
          </Button>
        </Modal.Footer>
      </Modal>
    </>

      {/* Modal to confirm sending invoice */}
      <Modal show={showConfirmConsultantInvoiceModal} onHide={() => setShowConfirmConsultantInvoiceModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send My Invoice?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p> The cost of your consultation is set at ${consultant?.consultationCharge}. Send ${consultant?.consultationCharge} invoice to this user? </p>
          {/* <p>  You can change the cost by clicking on the 'Charges' button on the dashboard</p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowConfirmConsultantInvoiceModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={sendConsultationInvoice}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

    {/* sacrifice invoice modal */}
    <Modal show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)} centered className="rounded-4" contentClassName="border-0 shadow-lg">
      <Modal.Header closeButton className="border-0 px-4 pt-4">
        <Modal.Title className="fw-semibold fs-5 text-primary">Enter Sacrifice Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4 pt-2">
        <div className="d-flex flex-column align-items-center gap-3 w-100">
          {/* <Form.Text className="text-muted w-100 text-start" style={{ fontSize: 13 }}>
            1 USD = 1 Cowrie
          </Form.Text> */}
          <input
            type="number"
            className="form-control text-center"
            style={{
              maxWidth: "320px",
              borderRadius: "12px",
              padding: "12px 16px",
              fontSize: "15px",
              border: "1px solid #dee2e6",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              transition: "all 0.3s ease"
            }}
            placeholder="Enter sacrifice amount (minimum 1.4)"
            value={sacrificeAmount}
            onChange={(e) => setSacrificeAmount(e.target.value)}
            min="1.4"
          />
          <select
              className="form-select"
              style={{
                borderRadius: "12px",
                padding: "10px 14px",
                fontSize: "15px",
                border: "1px solid #dee2e6"
              }}
              value={paymentCurrency}
              onChange={(e) => setPaymentCurrency(e.target.value)}
            >
              <option value="Naira">Naira</option>
              <option value="USD">Dollars</option>
          </select>
          <textarea
            className="form-control"
            placeholder="Describe the sacrifice"
            value={sacrificeDescription}
            onChange={(e) => setSacrificeDescription(e.target.value)}
            style={{ maxWidth: "320px", borderRadius: "12px", padding: "12px 16px", fontSize: "15px" }}
          />
          {/* <div className="w-100" style={{ maxWidth: "320px" }}>
            <Form.Label className="text-muted mb-1" style={{ fontSize: 13 }}>
              Choose Payment Method
            </Form.Label>
            <select
              className="form-select"
              style={{
                borderRadius: "12px",
                padding: "10px 14px",
                fontSize: "15px",
                border: "1px solid #dee2e6"
              }}
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="stripe">💳 Pay with Stripe</option>
              <option value="paystack">💰 Pay with Paystack</option>
            </select>
          </div> */}

          

          <Button
            variant="primary"
            className="fw-semibold mt-2"
            style={{
              padding: "10px 24px",
              borderRadius: "14px",
              fontSize: "15px",
              boxShadow: "0 4px 10px rgba(0, 123, 255, 0.2)",
              transition: "background-color 0.3s ease"
            }}
            onClick={handleSendInvoice}
            disabled={!sacrificeAmount || Number(sacrificeAmount) <= 1 || !sacrificeDescription}
          >
            Send Sacrifice Invoice
          </Button>
        </div>
      </Modal.Body>
    </Modal>

    <Modal show={showInvoicesModal} onHide={() => setShowInvoicesModal(false)} centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Invoices</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
          zIndex: 1055,
          transition: 'transform 0.3s ease-in-out',
            }}>
        {consultantInvoices.length === 0 ? (
          <p className="text-muted text-center">No invoices found.</p>
        ) : (
          consultantInvoices.map((invoice) => (
            <div key={invoice.id} className="card mb-3 shadow-sm border-0">
              <div className="card-body d-flex justify-content-between align-items-start">
              <div>
                  {/* <h5 className="card-title mb-2">Invoice</h5> */}
                  <p className="mb-1"><strong>Type:</strong> {invoice.text}</p>
                  <p className="mb-1">
                  <strong>Sent:</strong> {invoice.createdAt?.seconds
                      ? new Date(invoice.createdAt.seconds * 1000).toLocaleString()
                      : "Unknown date"}
                  </p> 
                  <p className="mb-1"><strong>Description:</strong> {invoice.description || 'No description'}</p>
                  <p className="mb-1"><strong>Amount:</strong> {invoice.amount} {invoice.currency}</p>
                  <p className="mb-2">
                    <strong>Status:</strong>{" "}
                    <span className={invoice.status === 'paid' ? "text-success" : "text-danger"}>
                      {invoice.status}
                    </span>
                  </p>
                                
                  
                  </div>

                {(invoice.status !== 'paid') && (
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDeleteInvoice(invoice.id)}
                  >
                    Delete
                  </Button>
                )}
              </div>
            </div>
          ))
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowInvoicesModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>




    <Offcanvas show={showMoreOptions} onHide={() => setShowMoreOptions(false)} placement="bottom"
       style={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          width: '300px',
          height: '220px',
          borderTopLeftRadius: '15px',
          borderTopRightRadius: '15px',
          boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
          zIndex: 1055,
          transition: 'transform 0.3s ease-in-out',
          backgroundColor: 'white', // Ensure it's visible
          // transform: showMoreOptions ? 'translateY(0)' : 'translateY(100%)',

            }}
    >
      <Offcanvas.Header  closeButton>
        {/* <Offcanvas.Title>More Options</Offcanvas.Title> */}
      </Offcanvas.Header>
      <Offcanvas.Body closeButton className="d-flex flex-column gap-2 mb-2">

        {/* <Button className="shadow-sm" variant={isDivining ? "success" : "outline-primary"}// Red for danger, Green for success

          style={{ 
            width: "100%", 
            padding: "10px",  
            borderRadius:5,
            // color: "white", // Ensure text remains readable
          }}
          // variant={isDivining ? "danger" : "success"}
          onClick={async () => {
            const newState = !isDivining; // First, calculate the new state
            await sendMessage2(newState); // Send message with new state
            setIsDivining(newState); // Update state after message is sent

            // Close the canvas after sending the message
            if (!newState) {
              setShowMoreOptions(false); // Only close when result is ready
            }
          }}
        >
          {isDivining ? "Send result ready alert 🔔" : "Send divination started alert 🔔"}
        </Button> */}

        {/* <Button
          variant="outline-primary"
          onClick={() => videoInputRef.current.click()}
        >
          Send Video 📀
        </Button>

        <input
            type="file"
            accept="video/*"
            style={{ display: "none" }}
            ref={videoInputRef}
            onChange={handleVideoUpload}
          /> */}

        <Button variant="outline-success" onClick={viewInvoices}>
          View Invoices
        </Button>
        <Button variant="outline-success" onClick={() =>setShowConfirmConsultantInvoiceModal(true)}>
          Send Consultation Invoice 🛒
        </Button>

        <Button variant="outline-success" onClick={() => setShowInvoiceModal(true)}>
          Send Sacrifice Invoice 🛍️
        </Button>


      </Offcanvas.Body>
    </Offcanvas>
    </div>




    
  );
        
       
//   );
};

export default ActiveConsultantChat;
